module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_05b.6f3b8bae.jpg";